const wholePath = window.document.location.href;
const pathName = window.document.location.pathname;
// const hostPath = window.location.hostname;
const hostPath = 'api';
const pathLength = wholePath.indexOf(pathName);
const projectName = pathName.substring(0, pathName.substr(1).indexOf('/') + 1);

Array.prototype.OrderByAsc = function (func) {
  let m = {};
  for (let i = 0; i < this.length; i++) {
    for (let k = 0; k < this.length; k++) {
      if (func === undefined) {
        if (this[i] < this[k]) {
          m = this[k];
          this[k] = this[i];
          this[i] = m;
        }
      } else {
        if (func(this[i]) < func(this[k])) {
          m = this[k];
          this[k] = this[i];
          this[i] = m;
        }
      }
    }
  }
  return this;
};

Array.prototype.OrderByDesc = function (func) {
  let m = {};
  for (let i = 0; i < this.length; i++) {
    for (let k = 0; k < this.length; k++) {
      if (func === undefined) {
        if (this[i] > this[k]) {
          m = this[k];
          this[k] = this[i];
          this[i] = m;
        }
      } else {
        if (func(this[i]) > func(this[k])) {
          m = this[k];
          this[k] = this[i];
          this[i] = m;
        }
      }
    }
  }
  return this;
};

/**
 * let now=(new Date()).Format("yyyy-MM-dd hh:mm:ss");//当前日期
 *(new Date()).Format("yyyy-MM-dd hh:mm:ss");//2018-01-22 12:00:00
 *(new Date()).Format("yyyy-MM-dd hh:mm");   //2018-01-22 12:00
 *(new Date()).Format("yyyy-MM-dd hh");      //2018-01-22 12
 *(new Date()).Format("yyyy-MM-dd");         //2018-01-22
 *(new Date()).Format("yyyy-MM");            //2018-01
 *(new Date()).Format("yyyy");               //2018
 */
Date.prototype.Format = function (format) {
  let o = {
    "M+": this.getMonth() + 1,  //month
    "d+": this.getDate(),     //day
    "h+": this.getHours(),    //hour
    "m+": this.getMinutes(),  //minute
    "s+": this.getSeconds(), //second
    "q+": Math.floor((this.getMonth() + 3) / 3),  //quarter
    "S": this.getMilliseconds() //millisecond
  };
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return format;
};


/**
 * 加法运算，避免数据相加小数点后产生多位数和计算精度损失。
 *
 * param this加数1 | num2加数2
 */
Number.prototype.numAdd = function (num2) {
  let baseNum, baseNum1, baseNum2;
  try {
    baseNum1 = this.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
  return (this * baseNum + num2 * baseNum) / baseNum;
};
/**
 * 减法运算，避免数据相减小数点后产生多位数和计算精度损失。
 *
 * param this被减数  |  num2减数
 */
Number.prototype.numSub = function (num2) {
  let baseNum, baseNum1, baseNum2;
  let precision;// 精度
  try {
    baseNum1 = this.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
  precision = (baseNum1 >= baseNum2) ? baseNum1 : baseNum2;
  return ((this * baseNum - num2 * baseNum) / baseNum).toFixed(precision);
};
/**
 * 乘法运算，避免数据相乘小数点后产生多位数和计算精度损失。
 *
 * param this被乘数 | num2乘数
 */
Number.prototype.numMulti = function (num2) {
  let baseNum = 0;
  try {
    baseNum += this.toString().split(".")[1].length;
  } catch (e) {
  }
  try {
    baseNum += num2.toString().split(".")[1].length;
  } catch (e) {
  }
  return Number(this.toString().replace(".", "")) * Number(num2.toString().replace(".", "")) / Math.pow(10, baseNum);
};
/**
 * 除法运算，避免数据相除小数点后产生多位数和计算精度损失。
 *
 * param this被除数 | num2除数
 */
Number.prototype.numDiv = function (num2) {
  let baseNum1 = 0, baseNum2 = 0;
  let baseNum3, baseNum4;
  try {
    baseNum1 = this.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  // with (Math) {
  baseNum3 = Number(this.toString().replace(".", ""));
  baseNum4 = Number(num2.toString().replace(".", ""));
  return (baseNum3 / baseNum4) * Math.pow(10, baseNum2 - baseNum1);
  // }
};

Number.prototype.numFixed = function (num) {
  if (num === 1) {
    // return (Math.ceil(this.numMulti(10))).numDiv(10);
    return this.numAdd(0.04).toFixed(num)
  } else if (num === 2) {
    // return (Math.ceil(this.numMulti(100))).numDiv(100);
    return this.numAdd(0.004).toFixed(num)
  } else if (num === 3) {
    // return (Math.ceil(this.numMulti(1000))).numDiv(1000);
    return this.numAdd(0.0004).toFixed(num)
  } else if (num === 4) {
    // return (Math.ceil(this.numMulti(10000))).numDiv(10000);
    return this.numAdd(0.00004).toFixed(num)
  } else if (num === 5) {
    // return (Math.ceil(this.numMulti(100000))).numDiv(100000);
    return this.numAdd(0.000004).toFixed(num)
  }
  return parseFloat(this).toFixed(num);
};

const parseTime = function (time, format) {
  if (arguments.length === 0) {
    return null;
  }
  const cformat = format || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time == 'object') {
    date = time;
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = cformat.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
};

const formatTime = function (time, option) {
  time = +time * 1000;
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
};

const getQueryObject = function (url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf('?') + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
};

const cleanArray = function (actual) {
  const newArray = [];
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
};

const json2Param = function (json) {
  if (!json) return '';
  let res = cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined) return '';
    return encodeURIComponent(key) + '=' +
      encodeURIComponent(json[key]);
  })).join('&');
  return res;
};

const param2Obj = function (url) {
  const search = url.split('?')[1];
  if (!search) {
    return {}
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
};

const html2Text = function (val) {
  const div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
};


// 获取手机号码归属运营商:
// 中国手机号段（截止19年5月）：13[0-9], 14[0,1,4,5,6,7,8]（14开头为数据卡或物联网卡）, 15[0, 1, 2, 3, 5, 6, 7, 8, 9],165,166,167, 17[0, 1, 4, 5, 6, 7, 8], 18[0-9],191,198,199
// 移动号段： 134,135,136,137,138,139,147,150,151,152,157,158,159,178,182,183,184,187,188,198
// 联通号段： 130,131,132,145,146,155,156,166,167,175,176,185,186
// 电信号段： 133,141,153,174,177,180,181,189,191,199
// 虚拟运营商移动号段： 165,1703,1705,1706
// 虚拟运营商联通号段： 1704,1707,1708,1709,171
// 虚拟运营商电信号段： 1700,1701,1702

const verifyPhone = function (val) {

  let MOBILE = "^1(3[0-9]|4[014-7]|5[0-35-9]|6[5-7]|7[014-8]|8[0-9]|9[189])\\d{8}$";

  let ISEMAIL = "^([a-zA-Z0-9_\\-\\.]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([a-zA-Z0-9\\-]+\\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})$"

  let EMAIL = "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"

  // 移动
  let CM = "^1(3[4-9]|4[478]|5[0-27-9]|7[8]|8[2-478]|98)\\d{8}$";
  // 联通
  let CU = "^1(3[0-2]|4[56]|5[56]|6[67]|7[56]|8[56])\\d{8}$";
  // 电信
  let CT = "^1(33|41|53|7[47]|8[019]|9[19])\\d{8}$";
  // 虚拟移动
  let VirtualCM = "(^165\\d{8}$)|(^170[356]\\d{7}$)";
  // 虚拟联通
  let VirtualCU = "(^170[47-9]\\d{7}$)|(^171\\d{8}$)";
  // 虚拟电信
  let VirtualCT = "^170[0-2]\\d{7}$";

  let dics = [
    {name: "MOBILE", rule: MOBILE},
    {name: "CM", rule: CM},
    {name: "CU", rule: CU},
    {name: "CT", rule: CT},
    {name: "VirtualCM", rule: VirtualCM},
    {name: "VirtualCU", rule: VirtualCU},
    {name: "VirtualCT", rule: VirtualCT}];

  // forEach 的 return 无法跳出循环
  // dics.forEach(item => {
  // dics.some(item => {
  let res = "";
  if (new RegExp(dics[0].rule).test(val)) {
    for (let i = 0; i < dics.length; i++) {
      let item = dics[i];
      let reg = new RegExp(item.rule);
      let result = reg.test(val);
      if (item.name === "MOBILE" && !result) {
        break; // is not a mobile
      } else if (item.name === "MOBILE") {
        continue; // is a mobile
      }

      if (result) {
        res = item.name;
        break;
      } else {
        continue;
      }
    }
  } else if (new RegExp(ISEMAIL).test(val)) {
    if (new RegExp(EMAIL).test(val)) {
      res = 'EMAIL'
    } else {
      res = 'notemail'
    }
  }

  return res;
};

const verifyCustom = function (val, rule) {
  let reg = new RegExp(rule);
  let result = reg.test(val);
  return result;
};

const isUnionPay = function (){
  let agent = navigator.userAgent.toLowerCase();
  return ((new RegExp(/(com.unionpay.chsp)/).test(agent)) || (new RegExp(/(com.unionpay.mobilepay)/).test(agent)));
}

const util = {
  PathWhole: wholePath,       // 全部路径
  PathName: pathName,         // 端口号后面的路径
  PathLength: pathLength,     // 全部长度
  PathHost: hostPath + '/',         // 完整域名
  PathProjectName: projectName,   // 端口号后面的项目名称

  formatTime: formatTime, //格式化时间
  getQueryObject: getQueryObject,
  json2Param: json2Param,
  param2Obj: param2Obj,
  html2Text: html2Text,
  verifyPhone: verifyPhone,
  verifyCustom: verifyCustom,
  isUnionPay
};

export default util


// export function getByteLen(val) {
//   let len = 0;
//   for (let i = 0; i < val.length; i++) {
//     if (val[i].match(/[^\x00-\xff]/ig) != null) {
//       len += 1;
//     } else {
//       len += 0.5;
//     }
//   }
//   return Math.floor(len);
// }
//
// export function cleanArray(actual) {
//   const newArray = [];
//   for (let i = 0; i < actual.length; i++) {
//     if (actual[i]) {
//       newArray.push(actual[i]);
//     }
//   }
//   return newArray;
// }
//
// export function objectMerge(target, source) {
//   /* Merges two  objects,
//    giving the last one precedence */
//
//   if (typeof target !== 'object') {
//     target = {};
//   }
//   if (Array.isArray(source)) {
//     return source.slice();
//   }
//   for (const property in source) {
//     if (source.hasOwnProperty(property)) {
//       const sourceProperty = source[property];
//       if (typeof sourceProperty === 'object') {
//         target[property] = objectMerge(target[property], sourceProperty);
//         continue;
//       }
//       target[property] = sourceProperty;
//     }
//   }
//   return target;
// }
//
// export function scrollTo(element, to, duration) {
//   if (duration <= 0) return;
//   const difference = to - element.scrollTop;
//   const perTick = difference / duration * 10;
//   setTimeout(() => {
//     console.log(new Date())
//     element.scrollTop = element.scrollTop + perTick;
//     if (element.scrollTop === to) return;
//     scrollTo(element, to, duration - 10);
//   }, 10);
// }
//
// export function toggleClass(element, className) {
//   if (!element || !className) {
//     return;
//   }
//   let classString = element.className;
//   const nameIndex = classString.indexOf(className);
//   if (nameIndex === -1) {
//     classString += '' + className;
//   } else {
//     classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
//   }
//   element.className = classString;
// }
//
// export const pickerOptions = [
//   {
//     text: '今天',
//     onClick(picker) {
//       const end = new Date();
//       const start = new Date(new Date().toDateString());
//       end.setTime(start.getTime());
//       picker.$emit('pick', [start, end]);
//     }
//   }, {
//     text: '最近一周',
//     onClick(picker) {
//       const end = new Date(new Date().toDateString());
//       const start = new Date();
//       start.setTime(end.getTime() - 3600 * 1000 * 24 * 7);
//       picker.$emit('pick', [start, end]);
//     }
//   }, {
//     text: '最近一个月',
//     onClick(picker) {
//       const end = new Date(new Date().toDateString());
//       const start = new Date();
//       start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
//       picker.$emit('pick', [start, end]);
//     }
//   }, {
//     text: '最近三个月',
//     onClick(picker) {
//       const end = new Date(new Date().toDateString());
//       const start = new Date();
//       start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
//       picker.$emit('pick', [start, end]);
//     }
//   }]
//
// export function getTime(type) {
//   if (type === 'start') {
//     return new Date().getTime() - 3600 * 1000 * 24 * 90
//   } else {
//     return new Date(new Date().toDateString())
//   }
// }
//
// export function debounce(func, wait, immediate) {
//   let timeout, args, context, timestamp, result;
//
//   const later = function () {
//     // 据上一次触发时间间隔
//     const last = +new Date() - timestamp;
//
//     // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
//     if (last < wait && last > 0) {
//       timeout = setTimeout(later, wait - last);
//     } else {
//       timeout = null;
//       // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
//       if (!immediate) {
//         result = func.apply(context, args);
//         if (!timeout) context = args = null;
//       }
//     }
//   };
//
//   return function (...args) {
//     context = this;
//     timestamp = +new Date();
//     const callNow = immediate && !timeout;
//     // 如果延时不存在，重新设定延时
//     if (!timeout) timeout = setTimeout(later, wait);
//     if (callNow) {
//       result = func.apply(context, args);
//       context = args = null;
//     }
//
//     return result;
//   };
// }



// WEBPACK FOOTER //
// ./src/utils/util.js